import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { getViewport } from '@/helpers/ui-helper';

import CustomInfiniteScroll from './CustomInfiniteScroll.vue';

interface InfiniteScrollProps {
	disabled?: boolean;
	loading?: boolean;
	hideSpinner?: boolean;
	scrollContainer?: HTMLElement | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InfiniteScroll',
  props: {
    disabled: { type: Boolean },
    loading: { type: Boolean },
    hideSpinner: { type: Boolean },
    scrollContainer: { default: null }
  },
  emits: ["load-next"],
  setup(__props: any, { expose }: { emit: ({ (e: 'load-next', payload: { event: any }): void }), expose: any, slots: any, attrs: any }) {





const thresholdValue = computed(() => {
	// this is to prevent sluggish infinite scroll triggers
	let value = '80%';
	switch (getViewport()) {
		case 'tablet':
			value = '150%';
			break;
		case 'smartphone':
			value = '260%';
			break;
	}
	return value;
});

// It should be called after each manually fetched first pages (e.g. in a parent stateful component "mounted" hook)
// to ensure that the content from the first page is actually fitting our threshold criteria, even
// before the user starts scrolling.

// In real life, calling it is not mandatory if the first page is 100% sure to be large enough to meet
// our threshold (e.g. popular view).
const infiniteScroll = ref<InstanceType<typeof CustomInfiniteScroll> | null>(null);

/** Manually triggers an infinite scroll recomputation, without having to wait for a scroll event. */
function reset() {
	if (infiniteScroll.value == null) return;

	infiniteScroll.value.reset();
	infiniteScroll.value.refresh();
}

expose({ reset });

return { __sfc: true,thresholdValue, infiniteScroll, reset, CustomInfiniteScroll }
}

})